// PageHeader.jsx
import React from "react";
import { Box, Typography, TextField, Button } from "@mui/material";
import { motion } from "framer-motion";
import AddIcon from "@mui/icons-material/Add";

export const PageHeader = ({ title, date }) => (
  <Box sx={{ position: "relative", width: "200px", height: 64, mb: 1 }}>
    <Typography
      variant="h4"
      fontWeight="bold"
      sx={{
        position: "absolute",
        left: 0,
        top: 0,
        color: "text.primary",
        fontFamily: "Poppins",
      }}
    >
      {title}
    </Typography>
    <Typography
      variant="body2"
      sx={{
        position: "absolute",
        left: 0,
        top: 40,
        color: "text.secondary",
        fontFamily: "Poppins",
      }}
    >
      {date}
    </Typography>
  </Box>
);

export const SearchWithAction = ({
  placeholder,
  buttonText,
  onButtonClick,
}) => (
  <Box sx={{ display: "flex", gap: 2, right: 0, top: 12 }}>
    {/* <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4 }}
        >
            <TextField
                variant="outlined"
                size="small"
                placeholder={placeholder}
                sx={{
                    width: 240,
                    backgroundColor: 'back',
                    borderRadius: 1.25,
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'grey.300',
                    },
                }}
            />
        </motion.div> */}

    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        // color="secondary"
        onClick={onButtonClick}
        size="small"
        sx={{ borderRadius: 1.25, fontFamily: "Poppins", fontWeight: 600 }}
      >
        {buttonText}
      </Button>
    </motion.div>
  </Box>
);
